import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BodyClassService {

  constructor() { }

  addBodyClass(className: string): void {
    if (typeof document !== 'undefined' && document.body) {
      document.body.classList.add(className);
    }
  }

  removeBodyClass(className: string): void {
    if (typeof document !== 'undefined' && document.body) {
      document.body.classList.remove(className);
    }
  }

  setBodyClass(className: string): void {
    this.clearAllBodyClasses();
    if (className && typeof document !== 'undefined' && document.body) {
      document.body.classList.add(className);
    }
  }

  hasBodyClass(className: string): boolean {
    if (typeof document !== 'undefined' && document.body) {
      return document.body.classList.contains(className);
    }
    return false;
  }

  clearAllBodyClasses(): void {
    if (typeof document !== 'undefined' && document.body) {
      document.body.className = '';
    }
  }

  setHeroMode(isHero: boolean): void {
    if (isHero) {
      this.addBodyClass('body-hero');
      this.removeBodyClass('body-background');
    } else {
      this.removeBodyClass('body-hero');
      this.addBodyClass('body-background');
    }
  }
}